import classes from '../../data/classes';
import { ruleCounts, gameDifficulty } from '../../data/difficulty';

const getPlayedClass = (state) => {
  if (
    state.game.players[state.game.controlledPlayer].playedClass !== 'RANDOM'
  ) {
    return classes[state.game.players[state.game.controlledPlayer].playedClass];
  }
  return null;
};

const getGameDifficulty = (state) => {
  return gameDifficulty[state.game.currentGameDifficulty].name;
};

const getPhaseGoalsForCurrentPhase = (state) => {
  return state.game.phaseGoals.filter(
    (goal) => goal.phase === state.game.currentPhase,
  );
};

const allCurrentPhaseGoalsDone = (state) => {
  let doneCount = 0;
  let phaseGoalCount = 0;
  state.game.players[state.game.controlledPlayer].phaseGoals.forEach((goal) => {
    if (goal.phase === state.game.currentPhase) {
      phaseGoalCount += 1;
    }
    if (goal.phase === state.game.currentPhase && goal.done) {
      doneCount += 1;
    }
  });
  return doneCount === phaseGoalCount;
};

const getTokensPerPhase = (state) => {
  return ruleCounts[state.settings.difficulty].tokensPerPhase;
};

export {
  getPlayedClass,
  getGameDifficulty,
  getPhaseGoalsForCurrentPhase,
  allCurrentPhaseGoalsDone,
  getTokensPerPhase,
};
